import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "app/shared";
import { PaymentsService } from "app/shared/payments.service";

@Component({
  selector: "app-payment-widget",
  templateUrl: "./payment-widget.component.html",
  styleUrls: ["./payment-widget.component.scss"],
})
export class PaymentWidgetComponent {
  constructor(
    private paymentsService: PaymentsService,
    public auth: AuthService,
    private router: Router
  ) {}

  readonly infinity = "Ꝏ";
  availableOrders = 0;
  paidOrders = 0;
  unlimited = false;

  get availableCount() {
    return this.unlimited ? this.infinity : this.availableOrders;
  }

  get paidCount() {
    return this.unlimited ? this.infinity : this.paidOrders;
  }

  updateStatus() {
    this.paymentsService.getPaymentStatus().subscribe((value) => {
      this.unlimited = value.unlimited;
      this.availableOrders = value.availableOrders;
      this.paidOrders = value.paidOrders;
    });
  }

  openPaymentPage() {
    if (this.auth.admin) {
      this.router.navigateByUrl("/admin/payment");
    }
  }
}
